import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithRedirect, getRedirectResult, getAdditionalUserInfo, OAuthProvider} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyD_pSYxtIfixNi4UghTz22HKxmDxdzSI9g",
    authDomain: "flixlatinosns.firebaseapp.com",
    databaseURL: "https://flixlatinosns.firebaseio.com",
    projectId: "flixlatinosns",
    storageBucket: "flixlatinosns.appspot.com",
    messagingSenderId: "249867889998",
    appId: "1:249867889998:web:4028e87b85058ce9b7c21f"
};

export enum ProviderType{
    google = "google.com",
    apple = "apple.com"
}

export class FirebaseService{
    
    public app;

    constructor(){
        this.app = initializeApp(firebaseConfig);
    }

    public launchGoogleAuth(){
        // const provider = new OAuthProvider("apple.com");
        const provider = new GoogleAuthProvider();
        provider.addScope('profile');

        const auth = getAuth();

        signInWithRedirect(auth, provider);

    }   

    public handleLoginRedirectResult(){
        const auth = getAuth();
        return getRedirectResult(auth)
            .then((result) => {
                if(result == null){
                    return;
                }

                const additionalInfo = getAdditionalUserInfo(result)
                if(additionalInfo == null || additionalInfo.profile == null){
                    return;
                }
                const profile = additionalInfo.profile;
                return {
                    email: profile.email,
                    identifier: profile.id,
                    type: additionalInfo.providerId == ProviderType.google ? ProviderType.google : ProviderType.apple
                }

            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = GoogleAuthProvider.credentialFromError(error);
                // ...
            });
    }

}